import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 351 312',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="hotel-solid" transform="translate(-406 -76)">
      <path
        fill={fill}
        id="hotel-solid-2"
        data-name="hotel-solid"
        d="M341.25,39A9.747,9.747,0,0,0,351,29.25V9.75A9.747,9.747,0,0,0,341.25,0H9.75A9.747,9.747,0,0,0,0,9.75v19.5A9.747,9.747,0,0,0,9.75,39h9.738V273H9.75A9.747,9.747,0,0,0,0,282.75v19.5A9.747,9.747,0,0,0,9.75,312H156V263.25a9.779,9.779,0,0,1,9.75-9.75h19.5a9.779,9.779,0,0,1,9.75,9.75V312H341.25a9.747,9.747,0,0,0,9.75-9.75v-19.5a9.747,9.747,0,0,0-9.75-9.75H331.5V39ZM156,66.3a8.388,8.388,0,0,1,7.8-7.8h23.4a8.388,8.388,0,0,1,7.8,7.8V89.7a8.388,8.388,0,0,1-7.8,7.8H163.8a8.388,8.388,0,0,1-7.8-7.8V66.3Zm0,58.5a8.388,8.388,0,0,1,7.8-7.8h23.4a8.388,8.388,0,0,1,7.8,7.8v23.4a8.388,8.388,0,0,1-7.8,7.8H163.8a8.388,8.388,0,0,1-7.8-7.8V124.8ZM78,66.3a8.388,8.388,0,0,1,7.8-7.8h23.4a8.388,8.388,0,0,1,7.8,7.8V89.7a8.388,8.388,0,0,1-7.8,7.8H85.8A8.388,8.388,0,0,1,78,89.7V66.3ZM109.2,156H85.8a8.388,8.388,0,0,1-7.8-7.8V124.8a8.388,8.388,0,0,1,7.8-7.8h23.4a8.388,8.388,0,0,1,7.8,7.8v23.4a8.388,8.388,0,0,1-7.8,7.8Zm7.8,78a58.5,58.5,0,0,1,117,0Zm156-85.8a8.388,8.388,0,0,1-7.8,7.8H241.8a8.388,8.388,0,0,1-7.8-7.8V124.8a8.388,8.388,0,0,1,7.8-7.8h23.4a8.388,8.388,0,0,1,7.8,7.8v23.4Zm0-58.5a8.388,8.388,0,0,1-7.8,7.8H241.8a8.388,8.388,0,0,1-7.8-7.8V66.3a8.388,8.388,0,0,1,7.8-7.8h23.4a8.388,8.388,0,0,1,7.8,7.8Z"
        transform="translate(406 76)"
      />
    </g>
  </svg>
);

export default SVG;
